module.exports = __webpack_public_path__ + "static/media/redSmiley.2bcfb43d.png";